import React, { FC } from 'react';
import sty from 'components/Modal/Modal.module.css';

interface Props {
  buttonTitle?: string;
  noBorderRadiusOnTablet?: boolean;
  blurBackground?: boolean;
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: FC<Props> = ({
  children,
  noBorderRadiusOnTablet,
  blurBackground,
  onClose,
  show,
}) => {
  const borderRadius = noBorderRadiusOnTablet ? sty.modal_square : '';
  const blur = blurBackground ? sty.modal_blur : '';
  const close = show ? '' : sty.modal_close;
  const modalClassName = `${sty.modal} ${close}`;

  const closeModal = (e: React.MouseEvent<EventTarget>) => {
    const el = e.target as HTMLElement;
    if (el.classList.value.includes(modalClassName)) {
      onClose();
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={`${modalClassName} ${borderRadius} ${blur}`}
      onClick={closeModal}
    >
      <div>{children}</div>
    </div>
  );
};

export default Modal;
